/* Kinetic Activewear — features.js
   Predictive search, slideshow, countdown, product gallery,
   lookbook hotspots, recommendations, recently viewed,
   sticky ATC, size guide modal, filters, scroll reveal */
(function () {
  'use strict';

  function money(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* ---------- predictive search ---------- */
  var searchInput = document.querySelector('#SearchBar input[type="search"]');
  var predictive = document.getElementById('PredictiveResults');
  if (searchInput && predictive) {
    var debounceTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { predictive.classList.remove('is-open'); return; }
      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { predictive.classList.remove('is-open'); return; }
            var html = '<div class="predictive-results__inner"><div class="predictive-results__grid">';
            products.forEach(function (p) {
              html += '<a class="predictive-item" href="' + esc(p.url) + '">' +
                (p.featured_image && p.featured_image.url
                  ? '<img src="' + esc(p.featured_image.url) + '&width=120" alt="" loading="lazy">'
                  : '<span style="width:56px;height:70px;background:#F1EDE6;display:block;"></span>') +
                '<span><span class="predictive-item__title">' + esc(p.title) + '</span><br>' +
                '<span class="predictive-item__price">' + esc(p.price ? String(p.price) : '') + '</span></span></a>';
            });
            html += '</div><a class="predictive-results__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results</a></div>';
            predictive.innerHTML = html;
            predictive.classList.add('is-open');
          })
          .catch(function () {});
      }, 250);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#SearchBar')) predictive.classList.remove('is-open');
    });
  }

  /* ---------- slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('.slideshow__track');
    var slides = root.querySelectorAll('.slideshow__slide');
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('.slideshow__dot');
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
    var timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { go(index + 1); }, speed);
    }
    root.querySelectorAll('[data-slide-prev]').forEach(function (b) {
      b.addEventListener('click', function () { go(index - 1); restart(); });
    });
    root.querySelectorAll('[data-slide-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(index + 1); restart(); });
    });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { go(di); restart(); });
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    restart();
  });

  /* ---------- countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var end = new Date(root.getAttribute('data-countdown'));
    if (isNaN(end.getTime())) return;
    var days = root.querySelector('[data-cd-days]');
    var hours = root.querySelector('[data-cd-hours]');
    var mins = root.querySelector('[data-cd-mins]');
    var secs = root.querySelector('[data-cd-secs]');
    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        var section = root.closest('.countdown-banner');
        if (section) section.style.display = 'none';
        clearInterval(t);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff % 86400000 / 3600000);
      var m = Math.floor(diff % 3600000 / 60000);
      var s = Math.floor(diff % 60000 / 1000);
      if (days) days.textContent = d;
      if (hours) hours.textContent = ('0' + h).slice(-2);
      if (mins) mins.textContent = ('0' + m).slice(-2);
      if (secs) secs.textContent = ('0' + s).slice(-2);
    }
    var t = setInterval(tick, 1000);
    tick();
  });

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var track = root.querySelector('.gallery-stage__track');
    var items = root.querySelectorAll('.gallery-stage__item');
    var thumbs = root.querySelectorAll('.gallery-thumb');
    if (!track) return;
    function setActive(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });
    root.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.hasAttribute('data-gallery-next') ? 1 : -1;
        var current = Math.round(track.scrollLeft / track.clientWidth);
        var next = Math.max(0, Math.min(items.length - 1, current + dir));
        track.scrollTo({ left: track.clientWidth * next, behavior: 'smooth' });
        setActive(next);
      });
    });
    track.addEventListener('scroll', function () {
      clearTimeout(track._st);
      track._st = setTimeout(function () {
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    });
  });

  /* ---------- lookbook hotspots ---------- */
  document.querySelectorAll('[data-hotspot]').forEach(function (spot) {
    spot.addEventListener('click', function (e) {
      e.stopPropagation();
      var card = document.getElementById(spot.getAttribute('data-hotspot'));
      if (!card) return;
      var wasOpen = card.classList.contains('is-open');
      document.querySelectorAll('.hotspot-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      if (wasOpen) return;
      var wrap = spot.closest('.lookbook__media');
      var x = parseFloat(spot.style.left);
      var y = parseFloat(spot.style.top);
      card.style.left = (x > 55 ? x - 38 : x + 4) + '%';
      card.style.top = Math.min(y + 4, 78) + '%';
      card.classList.add('is-open');
      void wrap;
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hotspot-card')) {
      document.querySelectorAll('.hotspot-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
    }
  });

  /* ---------- product recommendations ---------- */
  document.querySelectorAll('[data-recommendations-url]').forEach(function (root) {
    fetch(root.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var temp = document.createElement('div');
        temp.innerHTML = text;
        var fresh = temp.querySelector('[data-recommendations-content]');
        if (fresh && fresh.children.length) {
          root.querySelector('[data-recommendations-content]').innerHTML = fresh.innerHTML;
        } else {
          root.style.display = 'none';
        }
      })
      .catch(function () { root.style.display = 'none'; });
  });

  /* ---------- recently viewed ---------- */
  var RV_KEY = 'kinetic:recently-viewed';
  function readRV() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  var pageProduct = document.querySelector('[data-product-handle]');
  if (pageProduct) {
    var handle = pageProduct.getAttribute('data-product-handle');
    var list = readRV().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(function (root) {
    var exclude = root.getAttribute('data-exclude') || '';
    var handles = readRV().filter(function (h) { return h !== exclude; }).slice(0, 8);
    if (!handles.length) { root.style.display = 'none'; return; }
    var target = root.querySelector('[data-rv-grid]');
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) {
        if (!r.ok) throw new Error('gone');
        return r.json();
      }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { root.style.display = 'none'; return; }
      target.innerHTML = products.map(function (p) {
        var img = p.featured_image
          ? '<img src="' + esc(p.featured_image) + '" alt="" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;">'
          : '';
        return '<div class="product-card"><a href="' + esc(p.url) + '">' +
          '<div class="product-card__media">' + img + '</div>' +
          '<div class="product-card__info">' +
          '<h3 class="product-card__title">' + esc(p.title) + '</h3>' +
          '<div class="product-card__price"><span class="price">' + money(p.price) + '</span></div>' +
          '</div></a></div>';
      }).join('');
    });
  });

  /* ---------- sticky add to cart ---------- */
  var stickyBar = document.getElementById('StickyATC');
  var productForm = document.querySelector('form[data-product-form]');
  if (stickyBar && productForm && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(productForm);
    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        productForm.requestSubmit ? productForm.requestSubmit() : productForm.submit();
      });
    }
  }

  /* ---------- modals (size guide) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var m = document.getElementById(opener.getAttribute('data-modal-open'));
      if (m) m.classList.add('is-open');
      return;
    }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal__overlay')) {
      var open = e.target.closest('.modal');
      if (open) open.classList.remove('is-open');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    }
  });

  /* ---------- filter auto-submit ---------- */
  var filterForm = document.getElementById('FilterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"]')) filterForm.submit();
    });
  }

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll('.section-header, .product-card, .category-tile, .testimonial-card, .image-with-text__content, .rich-text');
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          ro.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(function (el) {
      el.classList.add('reveal');
      ro.observe(el);
    });
  }
})();
